import { di } from 'react-magnetic-di';
import { useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { useIsChannelErrorPresent } from '../../../store/converse';

export const useIsInputShown = () => {
    di(useProvider, useIsChannelErrorPresent);
    const provider = useProvider();
    const [isChannelErrorPresent] = useIsChannelErrorPresent();

    if (provider === 'AI_ANSWERS') {
        return !isChannelErrorPresent;
    }

    return true;
};
